import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { MonitorIcon, MessageSquareIcon, CoffeeIcon } from 'lucide-react';
const painPoints = [{
  icon: MonitorIcon,
  title: 'El "Glitch" del Zoom',
  description: 'Te piden una opinión y tu cerebro se pone en blanco.'
}, {
  icon: MessageSquareIcon,
  title: 'La Ansiedad del Slack',
  description: 'Borras y escribes el mismo mensaje 10 veces por miedo a sonar "raro".'
}, {
  icon: CoffeeIcon,
  title: 'El Café Incómodo',
  description: 'Evitas la cocina para no tener que inventar conversación trivial con tu jefe.'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5
    }
  }
};
export function ConflictSection() {
  return <section className="py-20 md:py-32 px-6 max-w-3xl mx-auto" data-id="element-1">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="mb-16" data-id="element-2">
        <h2 className="text-3xl md:text-4xl font-extrabold text-black mb-6 tracking-tight" data-id="element-3">
          ¿Tu carrera está estancada porque "no sabes hablar"?
        </h2>
        <p className="text-lg text-gray-600 leading-relaxed" data-id="element-4">
          Sabemos que eres bueno en lo que haces. Pero en la oficina de 2026, el
          talento no es suficiente si el pánico social te deja mudo:
        </p>
      </motion.div>

      <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
      once: true
    }} className="space-y-6 mb-16" data-id="element-5">
        {painPoints.map((point, index) => <motion.div key={index} variants={itemVariants} className="flex items-start gap-5 p-6 rounded-2xl bg-gray-50 border border-gray-100" data-id="element-6">
            <div className="bg-white p-3 rounded-xl shadow-sm border border-gray-100 shrink-0" data-id="element-7">
              <point.icon className="w-6 h-6 text-black" data-id="element-8" />
            </div>
            <div data-id="element-9">
              <h3 className="text-xl font-bold text-black mb-2" data-id="element-10">
                {point.title}
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-11">
                {point.description}
              </p>
            </div>
          </motion.div>)}
      </motion.div>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6,
      delay: 0.4
    }} data-id="element-12">
        <p className="text-xl font-bold text-black text-center italic" data-id="element-13">
          No es timidez. Es falta de las herramientas adecuadas.
        </p>
      </motion.div>
    </section>;
}